import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './core/services/auth-guard.service';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { LandingResolver } from './landing/landing.resolver';
import { PaymentPageComponent } from './landing/payment-page/payment-page.component';
import { IylonProductsComponent } from './mobile/iylon-products/iylon-products.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { IylonConnectComponent } from './iylon-connect/iylon-connect.component';
import { ConnectPaymentComponent } from './connect-payment/connect-payment.component';
import { CommonTableGridComponent } from './shared/components/common-table-grid/common-table-grid.component';

const routes: Routes = [{
  path: 'home',
  loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
},
{
  path: 'login',
  loadChildren: () => import('./login/login.module').then(m => m.LoginModule)
},
{
  path: 'resetPassword/:resetLink',
  component: ResetPasswordComponent
},
{
  path: 'forgotPassword',
  component: ForgotPasswordComponent
},
{
  path: 'iylonConnect/:selectedDetails',
  component: IylonConnectComponent
},
{
  path: 'iylonConnect',
  component: IylonConnectComponent
},
{
  path: 'iylonConnectPayment/:details',
  component: ConnectPaymentComponent
},
{
  path: 'register',
  loadChildren: () => import('./register/register.module').then(m => m.RegisterModule)
},
{
  path: 'landing',
  loadChildren: () => import('./landing/landing.module').then(m => m.LandingModule),
  canActivate: [AuthGuard],
  resolve: { userDetails: LandingResolver }
},
{ path: 'payment-Page/:paymentData',component:PaymentPageComponent},
{ path: 'mobile/iylon-products/:paymentData',component:IylonProductsComponent},
{
  path: '',
  redirectTo: 'home',
  pathMatch: 'full'
},
{
  path: 'test',
  component: CommonTableGridComponent
},
{
  path: '**',
  redirectTo: 'home'
}];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true, onSameUrlNavigation: 'reload', relativeLinkResolution: 'legacy' })],
  exports: [RouterModule],
  providers: [AuthGuard]
})
export class AppRoutingModule { }
